import {
  buildSncrConsultaUrl,
  resolveReceituarioProfile,
} from "src-next/modules/sncr";

import { MedicationSpecialControl } from "../MedicationSpecialControl";
import { NotificationReceitaAB } from "./NotificationReceitaAB";
import { NotificationReceitaControleEspecial } from "./NotificationReceitaControleEspecial";
import { NotificationReceitaRetinoides } from "./NotificationReceitaRetinoides";
import { NotificationReceitaTalidomida } from "./NotificationReceitaTalidomida";

type Props = {
  filterSpecialMedication: any[];
  dataPdf: any;
  documentHasBackground: boolean;
  imgBase64: any;
  gender: "male" | "female";
  linkDocument?: string;
  qrCodeDataUrl?: string | null;
  qrCodeSncrDataUrl?: string | null;
};

export function SpecialReceituarioDispatcher({
  filterSpecialMedication,
  dataPdf,
  documentHasBackground,
  imgBase64,
  gender,
  linkDocument,
  qrCodeDataUrl,
  qrCodeSncrDataUrl,
}: Props) {
  const item = filterSpecialMedication?.[0];
  const profile = resolveReceituarioProfile(item || {});
  const sncrConsultaUrl = item?.sncrNumero
    ? buildSncrConsultaUrl(item.sncrNumero)
    : undefined;

  const common = {
    filterSpecialMedication,
    dataPdf,
    gender,
    linkDocument,
    qrCodeDataUrl,
    qrCodeSncrDataUrl,
    sncrConsultaUrl,
  };

  switch (profile.modelo) {
    case "NRA":
      return <NotificationReceitaAB letra="A" {...common} />;
    case "NRB":
      return <NotificationReceitaAB letra="B" {...common} />;
    case "NRB2":
      return <NotificationReceitaAB letra="B2" {...common} />;
    case "NRR":
      return <NotificationReceitaRetinoides {...common} />;
    case "NRT":
      return <NotificationReceitaTalidomida {...common} />;
    case "RCE":
      return <NotificationReceitaControleEspecial {...common} />;
    default:
      return (
        <MedicationSpecialControl
          gender={gender}
          filterSpecialMedication={filterSpecialMedication}
          dataPdf={dataPdf}
          documentHasBackground={documentHasBackground}
          imgBase64={imgBase64}
        />
      );
  }
}
